import React, { Component } from 'react';
import {
	EmailIcon,
	EmailShareButton,
	FacebookIcon,
	FacebookMessengerIcon,
	FacebookMessengerShareButton,
	FacebookShareButton,
	FacebookShareCount,
	InstapaperIcon,
	InstapaperShareButton,
	LineIcon,
	LineShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	LivejournalIcon,
	LivejournalShareButton,
	MailruIcon,
	MailruShareButton,
	OKIcon,
	OKShareButton,
	OKShareCount,
	PinterestIcon,
	PinterestShareButton,
	PinterestShareCount,
	PocketIcon,
	PocketShareButton,
	RedditIcon,
	RedditShareButton,
	RedditShareCount,
	TelegramIcon,
	TelegramShareButton,
	TumblrIcon,
	TumblrShareButton,
	TumblrShareCount,
	TwitterIcon,
	TwitterShareButton,
	ViberIcon,
	ViberShareButton,
	VKIcon,
	VKShareButton,
	VKShareCount,
	WeiboIcon,
	WeiboShareButton,
	WhatsappIcon,
	WhatsappShareButton,
	WorkplaceIcon,
	WorkplaceShareButton,
} from 'react-share';

import Loading from 'Demora/Loading';

import http from 'Demora/http';

import './SocialShare.scss';

import exampleImage from 'resources/assets/images/logo.png';

import modal from 'Demora/modals/modal';

class SocialShare extends Component {
	constructor() {
		super();

		this.state = {
			url: '',
		};
	}

	componentDidMount() {
		let props = this.props;

		let postId = props.post.id;

		http
			.post('/data/getPostLink?obj=' + postId)
			.then((data) => {
				this.setState({
					url: data.url,
				});
			})
			.catch((e) => {
				throw e;
			});
	}

	render() {
		let state = this.state;

		const shareUrl = state.url;
		const post = this.props.post;

		let title = '';

		if (post.m && post.m.m) {
			title = post.m.m.substr(0, 1500);
		}

		if (!state.url) {
			return <Loading />;
		}

		return (
			<div>
				<div
					className='Demo__container'
					onClick={() => {
						modal.close('social_share_modal');
					}}
				>
					<div className='Demo__some-network'>
						FaceBook
						<br />
						<FacebookShareButton
							url={shareUrl}
							quote={title}
							className='Demo__some-network__share-button'
						>
							<FacebookIcon size={64} round />
						</FacebookShareButton>
						<div>
							<FacebookShareCount
								url={shareUrl}
								className='Demo__some-network__share-count'
							>
								{(count) => count}
							</FacebookShareCount>
						</div>
					</div>
					{false && (
						<div className='Demo__some-network'>
							<FacebookMessengerShareButton
								url={shareUrl}
								appId='521270401588372'
								className='Demo__some-network__share-button'
							>
								<FacebookMessengerIcon size={64} round />
							</FacebookMessengerShareButton>
						</div>
					)}

					<div className='Demo__some-network'>
						Twitter
						<br />
						<TwitterShareButton
							url={shareUrl}
							title={title}
							className='Demo__some-network__share-button'
						>
							<TwitterIcon size={64} round />
						</TwitterShareButton>
						<div className='Demo__some-network__share-count'>&nbsp;</div>
					</div>

					{false && (
						<div className='Demo__some-network'>
							<TelegramShareButton
								url={shareUrl}
								title={title}
								className='Demo__some-network__share-button'
							>
								<TelegramIcon size={64} round />
							</TelegramShareButton>

							<div className='Demo__some-network__share-count'>&nbsp;</div>
						</div>
					)}
					<div className='Demo__some-network'>
						WhatsApp
						<br />
						<WhatsappShareButton
							url={shareUrl}
							title={title}
							separator=':: '
							className='Demo__some-network__share-button'
						>
							<WhatsappIcon size={64} round />
						</WhatsappShareButton>
						<div className='Demo__some-network__share-count'>&nbsp;</div>
					</div>

					<div className='Demo__some-network'>
						LinkedIn
						<br />
						<LinkedinShareButton
							url={shareUrl}
							className='Demo__some-network__share-button'
						>
							<LinkedinIcon size={64} round />
						</LinkedinShareButton>
					</div>

					{false && (
						<div className='Demo__some-network'>
							<PinterestShareButton
								url={String(window.location)}
								media={`${String(window.location)}/${exampleImage}`}
								className='Demo__some-network__share-button'
							>
								<PinterestIcon size={64} round />
							</PinterestShareButton>

							<div>
								<PinterestShareCount
									url={shareUrl}
									className='Demo__some-network__share-count'
								/>
							</div>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<VKShareButton
								url={shareUrl}
								image={`${String(window.location)}/${exampleImage}`}
								className='Demo__some-network__share-button'
							>
								<VKIcon size={64} round />
							</VKShareButton>

							<div>
								<VKShareCount
									url={shareUrl}
									className='Demo__some-network__share-count'
								/>
							</div>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<OKShareButton
								url={shareUrl}
								image={`${String(window.location)}/${exampleImage}`}
								className='Demo__some-network__share-button'
							>
								<OKIcon size={64} round />
							</OKShareButton>

							<div>
								<OKShareCount
									url={shareUrl}
									className='Demo__some-network__share-count'
								/>
							</div>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<RedditShareButton
								url={shareUrl}
								title={title}
								windowWidth={660}
								windowHeight={460}
								className='Demo__some-network__share-button'
							>
								<RedditIcon size={64} round />
							</RedditShareButton>

							<div>
								<RedditShareCount
									url={shareUrl}
									className='Demo__some-network__share-count'
								/>
							</div>
						</div>
					)}

					<div className='Demo__some-network'>
						Tumblr
						<br />
						<TumblrShareButton
							url={shareUrl}
							title={title}
							className='Demo__some-network__share-button'
						>
							<TumblrIcon size={64} round />
						</TumblrShareButton>
						<div>
							<TumblrShareCount
								url={shareUrl}
								className='Demo__some-network__share-count'
							/>
						</div>
					</div>
					{false && (
						<div className='Demo__some-network'>
							<LivejournalShareButton
								url={shareUrl}
								title={title}
								description={shareUrl}
								className='Demo__some-network__share-button'
							>
								<LivejournalIcon size={64} round />
							</LivejournalShareButton>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<MailruShareButton
								url={shareUrl}
								title={title}
								className='Demo__some-network__share-button'
							>
								<MailruIcon size={64} round />
							</MailruShareButton>
						</div>
					)}

					<div className='Demo__some-network'>
						Email
						<br />
						<EmailShareButton
							url={shareUrl}
							subject={title}
							body='body'
							className='Demo__some-network__share-button'
						>
							<EmailIcon size={64} round />
						</EmailShareButton>
					</div>
					{false && (
						<div className='Demo__some-network'>
							<ViberShareButton
								url={shareUrl}
								title={title}
								className='Demo__some-network__share-button'
							>
								<ViberIcon size={64} round />
							</ViberShareButton>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<WorkplaceShareButton
								url={shareUrl}
								quote={title}
								className='Demo__some-network__share-button'
							>
								<WorkplaceIcon size={64} round />
							</WorkplaceShareButton>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<LineShareButton
								url={shareUrl}
								title={title}
								className='Demo__some-network__share-button'
							>
								<LineIcon size={64} round />
							</LineShareButton>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<WeiboShareButton
								url={shareUrl}
								title={title}
								image={`${String(window.location)}/${exampleImage}`}
								className='Demo__some-network__share-button'
							>
								<WeiboIcon size={64} round />
							</WeiboShareButton>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<PocketShareButton
								url={shareUrl}
								title={title}
								className='Demo__some-network__share-button'
							>
								<PocketIcon size={64} round />
							</PocketShareButton>
						</div>
					)}
					{false && (
						<div className='Demo__some-network'>
							<InstapaperShareButton
								url={shareUrl}
								title={title}
								className='Demo__some-network__share-button'
							>
								<InstapaperIcon size={64} round />
							</InstapaperShareButton>
						</div>
					)}
				</div>
				<div style={{ wordBreak: 'break-all' }}>
					<div className='text-center'>Or, link direct to your post</div>
					<br />
					{shareUrl}
				</div>
			</div>
		);
	}
}

export default SocialShare;
